import {
  DATA_CONNECTOR_LOAD_COLLECTIONS_BEGIN,
  DATA_CONNECTOR_LOAD_COLLECTIONS_SUCCESS,
  DATA_CONNECTOR_LOAD_COLLECTIONS_FAILURE,
  DATA_CONNECTOR_LOAD_COLLECTIONS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_COLLECTIONS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionsError() {
  return {
    type: DATA_CONNECTOR_LOAD_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadCollectionsPending: true,
        loadCollectionsError: null,
      };

    case DATA_CONNECTOR_LOAD_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: null,
        collections: action.data ? action.data : [],
      };

    case DATA_CONNECTOR_LOAD_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadCollectionsPending: false,
        loadCollectionsError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionsError: null,
      };

    default:
      return state;
  }
}
